import React from 'react';
import Divider from '@material-ui/core/Divider';
import BusIcon from '@material-ui/icons/DirectionsBus';
import StarIcon from '@material-ui/icons/Star';
import SubwayIcon from '@material-ui/icons/Subway';

import useSideSheetStyles from './useSideSheetStyles';
import NavigationList from '../../NavigationList/NavigationList';
import { Typography } from '@material-ui/core';

const SideSheet = (props) => {
    const classes = useSideSheetStyles();
    const appName = 'Chicago PubTracker';
    const listItems = [
        {
            key: 1,
            text: 'CTA Bus',
            icon: <BusIcon />,
            path: '/'
        }, {
            key: 2,
            text: 'CTA L Train',
            icon: <SubwayIcon />,
            path: '/train'
        }, {
            key: 3,
            text: 'Favorites',
            icon: <StarIcon />,
            path: '/favorites'
        }
    ];

    return (
        <div>
            <div className={classes.sideSheetHeader}>
            <Typography variant="overline">{appName}</Typography>
            </div>
            <Divider />
            <NavigationList list={listItems}/> 
        </div>
    );
};

export default SideSheet;